<div class="ipm-dsc">
    <span class="ipm-dsc-glow" aria-hidden="true"></span>
    <div class="ipm-dsc-main">
        <span class="ipm-dsc-icon" aria-hidden="true">🪔</span>
        <div class="ipm-dsc-text">
            <p class="ipm-dsc-title"><span class="ipm-dsc-brand">Beat22</span> <span class="ipm-dsc-sale">Diwali Sale</span></p>
            <p class="ipm-dsc-desc">
                Up to {{beatOffer}} off on beats<ng-container *ngIf="startAt && endAt"> · <span class="ipm-dsc-dates">{{startAt | date : 'd MMM'}} – {{endAt | date : 'd MMM'}}</span></ng-container>
            </p>
        </div>
    </div>
    <!-- sale countdown on one line: "Sale starts in" before the sale, "Sale ends in" during it, hidden after -->
    <ipm-sale-countdown class="ipm-dsc-countdown" appearance="inline" *ngIf="startAt && endAt"
        [startAt]="startAt" [endAt]="endAt"></ipm-sale-countdown>
</div>
